'use client';
import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import style from './ServiceCardsSection.module.scss';
import { Card } from './components/Card';
import air_conditiong from '@/public/images/services/main_page/air_conditiong.webp';
import electrical from '@/public/images/services/main_page/electrical.webp';
import new_construction from '@/public/images/services/main_page/new_construction.webp';
import plumbing_solution from '@/public/images/services/main_page/plumbing_solution.webp';
import real_estate_brokerage from '@/public/images/services/main_page/real_estate_brokerage.webp';
import remodeling from '@/public/images/services/main_page/remodeling.webp';
import { Icons } from '@/components/icons';
import { usePathname } from 'next/navigation';

const data = [
  {
    title: 'Heating and Air Conditioning',
    description: `We provide a full range of HVAC services, whether you're looking for installation, repair, or maintenance of heating and cooling systems.`,
    image: air_conditiong,
    path: '/services/heating-and-air',
  },
  {
    title: 'Electrical Services',
    description: `We handle everything from lighting to wiring, ensuring your home stays bright and safe.`,
    image: electrical,
    path: '/services/electrical',
  },
  {
    title: 'Plumbing',
    description: `We make plumbing problems easy to solve so you can enjoy peace of mind. From leaky faucets to major repairs, we've got you covered.`,
    image: plumbing_solution,
    path: '/services/plumbing',
  },
  {
    title: 'Remodeling',
    description: `Transform your space with our expert construction services, designed to turn your ideas into reality with quality and efficiency.`,
    image: remodeling,
    path: '/services/remodeling',
  },
  {
    title: 'New Construction',
    description: `Ready to build your dream home? From planning to finishing, we handle every detail to bring your vision to life.`,
    image: new_construction,
    path: '/services/construction',
  },
  {
    title: 'Real Estate Brokerage',
    description: `Looking for a home or a commercial space? Our real estate team is dedicated to finding the perfect property for you.`,
    image: real_estate_brokerage,
    path: '/services/brokerage',
  },
];

export const ServiceCardsSection = ({
  shortVariant,
}: {
  shortVariant: boolean;
}) => {
  // const currentPath = 'window.location.pathname;';
  const currentPath = usePathname();
  const filteredItems = data.filter((item) => item.path !== currentPath);
  const items = shortVariant ? filteredItems.slice(0, 3) : filteredItems;
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <>
      {shortVariant && (
        <div className="mb-16 flex w-full items-center justify-between">
          <h2 className="text-4xl">
            <span className="text-textOrange">More of</span>{' '}
            <span className="text-black">our Services</span>
          </h2>
          <div className="flex justify-center ">
            <a
              href="/services"
              className="flex w-fit items-start gap-2 rounded-full border border-black bg-white px-3 py-2 text-start text-base text-black hover:bg-gray-200"
            >
              <span className="text-base">View All Services</span>{' '}
              <span>{<Icons.info />}</span>
            </a>
          </div>
        </div>
      )}
      <div ref={ref} className={style.wrapper}>
        {items.map((item, idx) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: idx * 0.1 }}
          >
            <Card {...item} />
          </motion.div>
        ))}
      </div>
    </>
  );
};
